// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { __rest } from "tslib";
import React from 'react';
import { TableTdElement } from '../body-cell/td-element';
import { ItemsLoader } from './items-loader';
export function TableLoaderCell(_a) {
    var { item, trackBy, children } = _a, props = __rest(_a, ["item", "trackBy", "children"]);
    return (React.createElement(TableTdElement, Object.assign({}, props, { isEditable: false, isEditing: false }), props.isRowHeader ? (React.createElement(ItemsLoader, { item: item, trackBy: trackBy }, children)) : null));
}
//# sourceMappingURL=loader-cell.js.map